module.exports = __webpack_public_path__ + "img/facebook_w.57349c52.svg";